import { RadioGroup, Box, Stack } from "@mui/material";
import { Offer } from "@covertree/new-business-graphql";

import { PersonalizedQuotesListCard } from "./PersonalizedQuotesListCard";
import { PersonalizedPlanDetailsType } from "../forms/personalizedPlans/personalizedPlans";
import { InfoDisclaimerBox } from "@covertree/ui/content";

interface Props {
  selectedQuote: string;
  isTenantFlow: boolean;
  shouldDisplayPremisesLiability: boolean;
  personalizedPlans: PersonalizedPlanDetailsType[];
  policyLocator: string;
  onPlanSelect(offer: Offer): void;
  isD2C?: boolean;
}

export function PersonalizedQuotesList({
  selectedQuote,
  isTenantFlow,
  shouldDisplayPremisesLiability,
  personalizedPlans,
  policyLocator,
  onPlanSelect,
  isD2C,
}: Props) {
  return (
    <RadioGroup
      sx={{
        marginTop: 2,
        marginBottom: 4,
        flexDirection: "column",
        flexWrap: "nowrap",
      }}>
      <InfoDisclaimerBox
        dataTestId="disclaimer-box-quotes-list"
        fontSize={15}
        mb={2}>
        You can review and edit coverages later in the flow on the{" "}
        <strong>Policy Summary</strong> page to ensure best pricing and
        protection for {isD2C ? "you." : "your client."}
        <span style={{ display: "block", marginTop: "2px" }}>
          Policy number: <strong>{policyLocator}</strong>
        </span>
      </InfoDisclaimerBox>
      <Stack direction="column" gap={2}>
        {personalizedPlans.map((offer, index) => (
          <Box key={index}>
            <PersonalizedQuotesListCard
              personalizedPlan={offer}
              isTenantFlow={isTenantFlow}
              shouldDisplayPremisesLiability={shouldDisplayPremisesLiability}
              selected={offer.quoteLocator === selectedQuote}
              onPlanPick={onPlanSelect}
            />
          </Box>
        ))}
      </Stack>
    </RadioGroup>
  );
}
